// extracted by mini-css-extract-plugin
export default {"searchform":"doctorsSearchBox_searchform__YKVCT","searchbox":"doctorsSearchBox_searchbox__7ZZAG","searchBtn":"doctorsSearchBox_searchBtn__PMMGF"};